import { Box, Collapse, Typography, IconButton, TablePagination } from "@mui/material";
import { PositionCategoryTableTitle } from "../../data/position.category.table.title";
import { PositionCategoryControllerAction, PositionCategoryControllerState } from "../../controller/position.category.controller";
import lineLoader from "../../../../components/lineLoader/lineLoader";
import { PositionCategoryModel } from "../../model/position.category.model";
const defaultStyle = { border: '1px solid #1A1A1A20', padding: 5, backgroundColor: '#EEEFF3' };
import DeleteIcon from '@mui/icons-material/Delete';
import BorderColorIcon from '@mui/icons-material/BorderColor';
import { CustomAlertAction, CustomAlertState } from "../../../../alert/controller/custom.alert.controller";
import { CustomAlertType } from "../../../../alert/data/custom.alert.type";
import { CustomAlertIcons } from "../../../../alert/data/custom.alert.icon";
import { PositionCategoryModalChildrenData } from "../../data/position.category.child";
import checkAuthController from "../../../../layouts/dashboard/controllers/check-auth.controller";
import { useEffect } from "react";
import { UserInfoModel } from "../../../user/models/user.model";
import { RoleChecker } from "../../../../utils/role-check-utils";
const CustomPositionCategoryTable = ({ cate, alert }: { cate: PositionCategoryControllerState & PositionCategoryControllerAction, alert: CustomAlertState & CustomAlertAction }) => {
    const checkUser = checkAuthController();
    useEffect(() => {
        checkUser.getLoginUser();
    }, []);

    const user: UserInfoModel | null = checkUser.loginUser;
    return (
        <Box sx={{
            overflowX: 'auto',
        }}>
            <Collapse unmountOnExit={true} orientation={"vertical"} in={cate.loading && cate?.listCount > 0 ? true : false}>
                {lineLoader()}
            </Collapse>
            <Collapse unmountOnExit={true} orientation={"vertical"} in={cate.loading == false || cate?.listCount > 0 ? true : false}>
                <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                    <thead>
                        <tr>
                            {PositionCategoryTableTitle?.map((label, index) => (
                                <th key={index} style={{ ...defaultStyle, backgroundColor: '#E4E8F3' }}>
                                    <Typography>
                                        {label.label}
                                    </Typography>
                                </th>
                            ))}
                        </tr>
                    </thead>

                    <tbody>
                        {cate?.listCate?.map((item: PositionCategoryModel, index: number) => (
                            <tr key={index}>
                                <td style={{ ...defaultStyle, textAlign: 'center' }}>
                                    <Typography>
                                        {index + 1}
                                    </Typography>
                                </td>


                                <td style={{ ...defaultStyle, textAlign: 'center' }}>
                                    <Typography>
                                        {item?.position_category_name_en ?? "*"}
                                    </Typography>
                                </td>

                                <td style={{ ...defaultStyle, textAlign: 'center', textWrap: "wrap" }}>
                                    <Typography>
                                        {item?.position_category_name_la}
                                    </Typography>
                                </td>

                                <td style={{ ...defaultStyle, textAlign: 'center' }}>
                                    <IconButton onClick={() => {
                                        cate.onUpdateFormUpdate({ id: item?.uuid, position_category_name_en: item.position_category_name_en, position_category_name_la: item?.position_category_name_la });
                                        cate.onHandleModal(PositionCategoryModalChildrenData[1]);
                                    }}>
                                        <BorderColorIcon />
                                    </IconButton>
                                    <IconButton
                                        disabled={RoleChecker(user) > 1}
                                        onClick={() => alert.handleCustomAlert({
                                            title: "ລົບຂໍ້ມູນ",
                                            message: "ທ່ານຕ້ອງການລົບຂໍ້ມູນແທ້ບໍ ?",
                                            type: CustomAlertType.WARNING,
                                            icon: CustomAlertIcons.deleteConfirm,
                                            negText: "ກັບຄືນ",
                                            posText: "ຢືນຢັນ",
                                            onPositive: () => {
                                                cate.onDelete(item.uuid);
                                                alert.handleCustomAlert(null);
                                            }
                                        })}>
                                        <DeleteIcon />
                                    </IconButton>
                                </td>
                            </tr>
                        ))}

                    </tbody>
                </table>

            </Collapse>
            <Box sx={{ display: "flex", flexDirection: "row", paddingRight: "20px", alignItems: "center" }}>
                <Typography paddingLeft={"20px"}>
                    ທັງໝົດ {cate?.listCount} ລາຍການ
                </Typography>
                <Box sx={{ flex: 1 }} />
                <TablePagination
                    component="div"
                    colSpan={3}
                    rowsPerPageOptions={[9, 10, 25, 50, 100]}
                    count={cate?.listCount}
                    page={cate?.page}
                    onPageChange={(_, newPage) => {
                        cate?.onPageChange(newPage, cate?.pageRowAmount);
                        cate?.cateGetData(true, { skip: cate?.pageRowAmount * newPage, take: cate?.pageRowAmount * (newPage + 1) });
                    }}
                    rowsPerPage={cate?.pageRowAmount ?? 9}
                    onRowsPerPageChange={(e) => {
                        cate?.onPageChange(0, Number.parseInt(e.target.value));
                        cate?.onFilterChange({ skip: 0, take: Number.parseInt(e.target.value) });
                        cate?.cateGetData(true, { skip: 0, take: Number.parseInt(e.target.value) });
                    }}
                />
            </Box>
        </Box >
    )
}

export default CustomPositionCategoryTable;